import QRCode from "qrcode";

export async function generateQRCode(
  url: string,
  filename: string,
): Promise<void> {
  try {
    const qrDataUrl = await QRCode.toDataURL(url);
    const link = document.createElement("a");
    link.href = qrDataUrl;
    link.download = `${filename}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error generating QR code:", error);
    throw new Error("Failed to generate QR code");
  }
}
